// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'
import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import {
    Divider,
    IconButton,
    Tooltip,
    Autocomplete,
    InputLabel,
    Select,
    MenuItem
} from '@mui/material'
import { useNavigate } from "react-router-dom";
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../components/icon';
import apiUrl from '../../../configs/constant';
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto';
import moment from 'moment'
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'
import { useToast } from '../../../components/ToastProvider';
import { createRoot } from 'react-dom/client';

export default function Index() {
    const { showToast, hideToast } = useToast();
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const [tabs, setTabs] = useState<string>("0")
    const [tglAwal, setTglAwal] = useState<string>(moment().subtract(3, 'months').startOf('month').format('YYYY-MM-DD'))
    const [tglAkhir, setTglAkhir] = useState<string>(moment().endOf('month').format('YYYY-MM-DD'))
    const [listData, setListData] = useState<any[]>([])
    const [selectedList, setSelectedList] = useState<any[]>([])
    const [selectedPo, setSelectedPo] = useState<any>(null)
    const [listGudang, setListGudang] = useState<any[]>([])
    const [listDoctag, setListDoctag] = useState<any[]>([])
    const [sysdoctagId, setSysdoctagId] = useState<string>('')

    useEffect(() => {
        getData(tabs)
        getListGudang()

        const getDoctag = () => {
            const url = apiUrl.apiUrl + '/system/doctag/list-combo'
            axios
                .get(url, {
                    params: {
                        syscabang_id: 1,
                        sysmenu_id: 40
                    },
                    headers: { Authorization: `Bearer ${token}` }
                })
                .then(response => {
                    if (response.data.success) {
                        const data = response.data.data
                        setListDoctag(data)
                    } else {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: response.data.message,
                            icon: 'error'
                        })
                    }
                })
        }

        getDoctag();
    }, [])

    const navigate = useNavigate();

    const getListGudang = () => {
        const url = apiUrl.apiUrl + '/mm/sub-gudang/list-combo'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListGudang(data)
                } else {
                    showToast(response.data.message, "error");
                }
            })

    }
    const getGudang = async () => {
        let options = listGudang;
        let selectedGudang: any = null;

        Swal.fire({
            title: 'Pilih Gudang',
            html: `<div id="swal-autocomplete"></div>`,
            showCancelButton: true,
            confirmButtonText: 'Simpan',
            cancelButtonText: 'Batal',
            willOpen: () => {
                const btn = Swal.getConfirmButton();
                if (btn) btn.disabled = true; // Disable tombol awalnya
            },
            didOpen: () => {
                const root = createRoot(document.getElementById('swal-autocomplete')!);

                root.render(
                    <Autocomplete
                        options={options}
                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                        onChange={(event, newValue) => {
                            selectedGudang = newValue;

                            const btn = Swal.getConfirmButton();
                            if (btn) {
                                btn.disabled = !newValue; // aktifkan hanya jika pilih supplier
                            }
                        }}
                        renderOption={(props: any, option: any) => (
                            <li {...props} key={option.id}>
                                {option.nama}
                            </li>
                        )}
                        getOptionLabel={(option: any) => option.nama}
                        renderInput={(params: any) => (
                            <TextField
                                {...params}
                                label='Pilih Gudang'
                                InputLabelProps={{ shrink: true }}
                            />
                        )}
                    />
                );
            },
            preConfirm: () => {
                if (!selectedGudang) {
                    Swal.showValidationMessage("Gudang wajib dipilih");
                    return false;
                }

                // Cek semua nama_vendor harus sama
                const selectedPoData = JSON.parse(selectedPo);
                const vendorNames = selectedPoData.map((item: any) => item.nama_vendor);
                const isVendorSame = vendorNames.every((vendor: string) => vendor === vendorNames[0]);

                if (!isVendorSame) {
                    Swal.showValidationMessage("Penerimaan harus dari vendor yang sama");
                    return false;
                }

                return {
                    detail: selectedPo,
                    mmgudang_id: selectedGudang.id,
                    syscabang_id: 1,
                };
            }
        }).then((result) => {
            if (result.isConfirmed && result.value) {
                saveGrMulti(result.value);
            }
        });
    }
    const saveGrMulti = (data: any) => {
        showToast("Loading", "loading");
        const send = {
            detail: selectedPo,
            mmgudang_id: data.mmgudang_id,
            syscabang_id: 1,
        }

        let url = apiUrl.apiUrl + '/purchasing/gr/add-gr-multi'

        axios
            .post(url, send, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    showToast(response.data.message, "success");
                    getData(tabs)
                } else {
                    showToast(response.data.message, "error");
                }
            })
            .catch(error => {
                showToast(error.message, "error");
            })
    }

    const getData = (mode: any) => {
        setListData([])
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        let url = apiUrl.apiUrl + '/purchasing/gr/list'

        axios
            .get(url, {
                params: {
                    awal: tglAwal,
                    akhir: tglAkhir,
                    mode: mode,
                    doctag:sysdoctagId
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const handleDelete = (row: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin hapus data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Hapus'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/purchasing/gr/delete/' + row
                axios
                    .delete(url, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    getData(tabs)
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    };

    const handleCancel = (row: any) => {
        Swal.fire({
            title: 'Alasan Cancel',
            input: 'textarea',
            inputLabel: 'Masukkan alasan pembatalan',
            inputPlaceholder: 'Tulis alasan cancel di sini...',
            inputAttributes: {
                'aria-label': 'Alasan cancel'
            },
            showCancelButton: true,
            confirmButtonText: 'Cancel Dokumen',
            cancelButtonText: 'Batal',
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            inputValidator: (value) => {
                if (!value) {
                    return 'Alasan wajib diisi!'
                }
            }
        }).then(result => {
            if (result.isConfirmed) {
                const alasan = result.value

                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/purchasing/gr/cancel/' + row.id

                axios.post(
                    url,
                    {
                        alasan: alasan
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                )
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    getData(tabs)
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    const handleChangeTabs = (event: SyntheticEvent, newValue: string) => {
        setTabs(newValue)
        getData(newValue)
    }

    const actionDataOustanding = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 120,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Tooltip title="Buat GR" placement="top">
                        <Box>
                            <IconButton onClick={() => navigate('/purchasing/good-receipt/add/' + row.id)}>
                                <Icon icon="mdi:plus-circle" color="primary" />
                            </IconButton>
                        </Box>
                    </Tooltip>
                    <Tooltip title="Cancel Penerimaan" placement="top">
                        <Box>
                            <IconButton onClick={() => {
                                handleCancel(row)
                            }}>
                                <Icon icon="mdi:trash-outline" color="primary" />
                            </IconButton>
                        </Box>
                    </Tooltip>
                </Box>
            ),

        },
    ];

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 180,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Tooltip title="Lihat Detail" placement="top">
                        <Box>
                            <IconButton onClick={() => {
                                if (row.sysdoctag_id === 6) {
                                    navigate('/purchasing/good-receipt/detail/' + row.id)
                                } else {
                                    navigate('/purchasing/good-receipt/detail-kain/' + row.id)
                                }
                            }}>
                                <Icon icon="mdi:search" color="primary" />
                            </IconButton>
                        </Box>
                    </Tooltip>
                    <Tooltip title="Print" placement="top">
                        <Box>
                            <IconButton onClick={() => window.open(apiUrl.baseUrl + '/purchasing/good-receipt/preview/' + row.id, '_blank')}>
                                <Icon icon="mdi:file-pdf" color="grey" />
                            </IconButton>
                        </Box>
                    </Tooltip>
                    <Tooltip title="Print" placement="top">
                        <Box>
                            <IconButton onClick={() => window.open(apiUrl.baseUrl + '/purchasing/good-receipt/nota/' + row.id, '_blank')}>
                                <Icon icon="mdi:printer" color="grey" />
                            </IconButton>
                        </Box>
                    </Tooltip>
                    <Tooltip title="Hapus GR" placement="top">
                        <Box>
                            <IconButton onClick={() => handleDelete(row.id)}>
                                <Icon icon="mdi:trash" color="red" />
                            </IconButton>
                        </Box>
                    </Tooltip>
                </Box>
            ),

        },
    ];

    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <CardHeader title='GOOD RECEIPT' />
                        </Box>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mr: 2 }}>
                        </Box>
                    </Box>
                    <Divider />
                    <CardContent>
                        <Grid
                            item
                            container
                            sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}
                            spacing={5}
                        >
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth>
                                    <InputLabel id='doctag-label'>Jenis Dokumen</InputLabel>
                                    <Select
                                        labelId='doctag-label'
                                        label='Jenis Dokumen'
                                        value={sysdoctagId}
                                        onChange={(e) => setSysdoctagId(e.target.value)}
                                    >
                                        {/* Option Semua */}
                                        <MenuItem value={0}>Semua Data</MenuItem>

                                        {/* List dari API */}
                                        {listDoctag.map((item) => (
                                            <MenuItem key={item.id} value={item.id}>
                                                {item.nama}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth>
                                    <TextField
                                        label='Tanggal Awal'
                                        type='date'
                                        onChange={(e) => setTglAwal(e.target.value)}
                                        value={tglAwal}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth>
                                    <TextField
                                        label='Tanggal Akhir'
                                        type='date'
                                        onChange={(e) => setTglAkhir(e.target.value)}
                                        value={tglAkhir}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <FormControl fullWidth>
                                    <Button
                                        variant='contained'
                                        sx={{ mt: 1 }}
                                        startIcon={<Icon icon='mdi:magnify' />}
                                        onClick={() => getData(tabs)}
                                    >
                                        Cari Data
                                    </Button>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </CardContent>
                    <TabContext value={tabs}>
                        <TabList
                            scrollButtons
                            variant='scrollable'
                            onChange={handleChangeTabs}
                            aria-label='forced scroll tabs example'
                        >
                            <Tab value='0' label='Daftar GR' />
                            <Tab value='4' label='Outstanding Belum Diterima' />
                            <Tab value='5' label='Daftar Cancel Terima' />
                        </TabList>
                        <TabPanel value='0'>
                            <MsiDatagrid array={listData} actions={actionData} hiddenColumns={["sysdoctag_id"]} />
                        </TabPanel>
                        <TabPanel value='4'>
                            {selectedList.length > 0 ? (
                                <Box
                                    sx={{
                                        gap: 2,
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'flex-start',
                                        p: theme => theme.spacing(2, 0, 0, 0)
                                    }}
                                >
                                    <Button
                                        variant='outlined'
                                        onClick={getGudang}
                                        startIcon={<Icon icon='mdi:text-box-check-outline' />}
                                    >
                                        Buat Penerimaan
                                    </Button>
                                </Box>
                            ) : null}
                            <MsiDatagrid array={listData} actions={actionDataOustanding} hiddenColumns={['id', 'id_supplier', 'id_barang']} />
                        </TabPanel>
                        <TabPanel value='5'>
                            <MsiDatagrid array={listData} />
                        </TabPanel>
                    </TabContext>
                </div>
            </Grid>
        </Grid>
    )
}
